<template>
  <img alt="Miramar logo" src="./assets/img_miplus.png" class="logo">
  <EmailLanding />
</template>

<script>
import EmailLanding from './components/EmailLanding.vue'

export default {
  name: 'App',
  components: {
    EmailLanding
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.logo {
  width: 180px;
  height: 125px;
}
@font-face {
    font-family: "Futura Light Italic font";
    src: url('~@/assets/fonts/Futura Light Italic font.ttf');
}
@font-face {
    font-family: "futura medium bt";
    src: url('~@/assets/fonts/futura medium bt.ttf');
}
@font-face {
    font-family: "Futura Medium Italic font";
    src: url('~@/assets/fonts/Futura Medium Italic font.ttf');
}
@font-face {
    font-family: "FuturaBookBT";
    src: url('~@/assets/fonts/FuturaBookBT.ttf');
}
</style>
